import { Link } from "react-router-dom";
import { LEGAL } from "@/lib/legal";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B0F17] border-t border-slate-800 px-4 py-3 text-center text-[11px] text-slate-400 leading-relaxed">
    © 2026 {LEGAL.company} (Wyoming, USA)
    <span className="block mt-1 flex flex-wrap justify-center gap-x-2 gap-y-0.5">
      <Link to="/mentions-legales" data-testid="footer-legal-link" className="text-sky-400 hover:underline">Mentions légales</Link>
      <span>·</span>
      <Link to="/cgu" data-testid="footer-cgu-link" className="text-sky-400 hover:underline">CGU</Link>
      <span>·</span>
      <Link to="/confidentialite" data-testid="footer-privacy-link" className="text-sky-400 hover:underline">Confidentialité</Link>
      <span>·</span>
      <Link to="/cookies" data-testid="footer-cookies-link" className="text-sky-400 hover:underline">Cookies</Link>
      <span>·</span>
      <a href={`mailto:${LEGAL.email}`} data-testid="footer-contact-link" className="text-sky-400 hover:underline">Contact</a>
    </span>
  </footer>
);
